module.exports = __webpack_public_path__ + "img/en-pc-banner.f4dfee26.png";